import moment from 'moment';
import toCurrency from 'utils/toCurrency';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import toast from 'react-hot-toast';
import Papa from 'papaparse';

export const exportNiplToXLS = (nipls, filename = 'data_nipl') => {
  if (!nipls || nipls.length === 0) {
    alert('Tidak ada data NIPL untuk di-export');
    return;
  }

  // Buat HTML table dengan styling yang lebih normal
  let htmlTable = `
    <html xmlns:o="urn:schemas-microsoft-com:office:office"
          xmlns:x="urn:schemas-microsoft-com:office:excel"
          xmlns="http://www.w3.org/TR/REC-html40">
    <head>
      <meta charset="UTF-8">
      <title>Data NIPL</title>
      <!--[if gte mso 9]>
      <xml>
        <x:ExcelWorkbook>
          <x:ExcelWorksheets>
            <x:ExcelWorksheet>
              <x:Name>Data NIPL</x:Name>
              <x:WorksheetOptions>
                <x:DisplayGridlines/>
                <x:Selected/>
                <x:ProtectContents>False</x:ProtectContents>
                <x:ProtectObjects>False</x:ProtectObjects>
                <x:ProtectScenarios>False</x:ProtectScenarios>
              </x:WorksheetOptions>
            </x:ExcelWorksheet>
          </x:ExcelWorksheets>
        </x:ExcelWorkbook>
      </xml>
      <![endif]-->
      <style>
        body {
          font-family: Arial, sans-serif;
          font-size: 11px; /* Ukuran font normal seperti Excel */
          margin: 0;
          padding: 20px;
        }
        table {
          border-collapse: collapse;
          width: 100%;
          font-size: 11px; /* Ukuran font tabel */
        }
        th {
          background-color: #f2f2f2;
          font-weight: bold;
          padding: 6px 8px;
          border: 1px solid #ddd;
          font-size: 11px;
          text-align: center;
        }
        td {
          padding: 6px 8px;
          border: 1px solid #ddd;
          font-size: 11px;
          vertical-align: top;
        }
        h2 {
          font-size: 14px;
          margin-bottom: 15px;
          color: #333;
        }
        .date-info {
          font-size: 10px;
          color: #666;
          margin-bottom: 15px;
        }
      </style>
    </head>
    <body>
      <h2>Data NIPL</h2>
      <div class="date-info">Diekspor pada: ${moment().format('DD MMM YYYY HH:mm')}</div>
      <table>
        <thead>
          <tr>
            <th>Tipe & NIPL</th>
            <th>Nama</th>
            <th>Harga</th>
            <th>Tanggal Pembelian</th>
            <th>Status</th>
            <th>Category</th>
          </tr>
        </thead>
        <tbody>
  `;

  // Tambahkan data rows
  nipls.forEach((data) => {
    const productTypeName = data?.product_type?.name || '-';
    const niplNumber = data?.nipl || '-';
    const customerName = data?.customer?.full_name || '-';
    const deposit = data?.deposit ? toCurrency(data.deposit) : '-';

    const transactionDate = data?.nipl_transaction?.created_at
      ? moment(data.nipl_transaction.created_at, 'YYYY-MM-DD[T]HH:mm:ss').format(
          'DD MMM YYYY HH:mm',
        )
      : '-';

    const statusBadge = findBadge(data?.status || '');
    const status = statusBadge.title;

    htmlTable += `
      <tr>
        <td>${productTypeName} - ${niplNumber}</td>
        <td>${customerName}</td>
        <td style="text-align: right;">${deposit}</td>
        <td>${transactionDate}</td>
        <td>${status}</td>
        <td>${productTypeName}</td>
      </tr>
    `;
  });

  htmlTable += `
        </tbody>
      </table>
    </body>
    </html>
  `;

  // Download file
  const blob = new Blob([htmlTable], {
    type: 'application/vnd.ms-excel;charset=utf-8',
  });
  const link = document.createElement('a');

  link.href = URL.createObjectURL(blob);
  link.download = `${filename}.xls`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
};

const findBadge = (status) => {
  switch (status) {
    // NIPL
    case 'ACTIVE':
      return { intent: 'solid-info', title: 'Active' };
    case 'WINNING':
      return { intent: 'solid-green', title: 'Menang' };
    case 'MANUAL':
      return { intent: 'solid-info', title: 'Manual' };
    case 'RETURNED':
      return { intent: 'solid-info', title: 'Refund' };
    case 'REQUEST-RETURN':
      return { intent: 'solid-amber', title: 'Request Refund' };
    case 'WANPRESTASI':
      return { intent: 'solid-red', title: 'Wanprestasi' };

    // Auction
    case 'PAID':
      return { intent: 'solid-green', title: 'Paid' };
    case 'CANCEL':
      return { intent: 'solid-red', title: 'Cancel' };
    case 'PENDING':
      return { intent: 'solid-amber', title: 'Pending' };

    // default
    default:
      return { intent: 'base-light', title: '-' };
  }
};

export const exportUserToXLS = (users, branchLocations, filename = 'data_user') => {
  if (!users || users.length === 0) {
    alert('Tidak ada data User untuk di-export');
    return;
  }

  let htmlTable = `
    <html xmlns:o="urn:schemas-microsoft-com:office:office"
          xmlns:x="urn:schemas-microsoft-com:office:excel"
          xmlns="http://www.w3.org/TR/REC-html40">
    <head>
      <meta charset="UTF-8">
      <title>Data User</title>

      <style>
        body { font-family: Arial, sans-serif; font-size: 11px; padding: 20px; }
        table { border-collapse: collapse; width: 100%; font-size: 11px; }
        th {
          background-color: #f2f2f2; font-weight: bold;
          padding: 6px 8px; border: 1px solid #ddd; text-align: center;
        }
        td {
          padding: 6px 8px; border: 1px solid #ddd; vertical-align: top;
        }
        h2 { font-size: 14px; margin-bottom: 15px; color: #333; }
        .date-info { font-size: 10px; color: #666; margin-bottom: 15px; }
      </style>
    </head>
    <body>
      <h2>Data User</h2>
      <div class="date-info">Diekspor pada: ${moment().format('DD MMM YYYY HH:mm')}</div>

      <table>
        <thead>
          <tr>
            <th>User Id</th>
            <th>Nama Lengkap</th>
            <th>Email</th>
            <th>No. Telepon</th>
            <th>Kata Sandi</th>
            <th>Peran</th>
            <th>Cabang</th>
          </tr>
        </thead>
        <tbody>
  `;

  users.forEach((user) => {
    const cabang = findObject(user?.branch_location_id, branchLocations)?.city_name ?? '-';

    htmlTable += `
      <tr>
        <td>${user?.id ?? '-'}</td>
        <td>${user?.name ?? '-'}</td>
        <td>${user?.email ?? '-'}</td>
        <td>'${user?.phone ?? '-'}</td>
        <td></td>
        <td>${user?.role?.name ?? '-'}</td>
        <td>${cabang}</td>
      </tr>
    `;
  });

  htmlTable += `
        </tbody>
      </table>
    </body>
    </html>
  `;

  const blob = new Blob([htmlTable], {
    type: 'application/vnd.ms-excel;charset=utf-8',
  });

  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = `${filename}.xls`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
};

const findObject = (id, array) => {
  return array.find((value) => value.id == id);
};

/* ============================================================
   1. BACA FILE EXCEL & TRANSFORMASI DATA → RETURN ARRAY OBJECT
   ============================================================ */
export const parseAndTransformExcel = async (fileBlob) => {
  try {
    // Convert Blob ke ArrayBuffer
    const arrayBuffer = await fileBlob.arrayBuffer();

    // Parse workbook
    const workbook = XLSX.read(arrayBuffer, { type: 'array' });

    // Ambil sheet pertama
    const sheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[sheetName];

    // Ambil header asli
    const sheetAsArray = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
    const originalHeaderRow = Array.isArray(sheetAsArray[0]) ? sheetAsArray[0] : [];

    // Helper cari index header
    const findHeaderIndex = (target) =>
      originalHeaderRow.findIndex(
        (h) =>
          String(h || '')
            .trim()
            .toLowerCase() === target.trim().toLowerCase(),
      );

    const poolAdiraIndex = findHeaderIndex('Pool Adira ID');

    // Ambil data body
    const data = XLSX.utils.sheet_to_json(worksheet, { defval: '' });

    // 🚀 Transformasi data
    const newData = data.map((row) => {
      const origId = row['ID Lelang'];
      const poolAdiraValue = row['Pool Adira ID'];

      let newId = origId;
      if (typeof origId === 'string' && poolAdiraValue) {
        const prefix3 = origId.slice(0, 3);
        const rest = origId.slice(3);
        newId = `${prefix3}-${poolAdiraValue}-${rest}`;
      }

      // Buat row baru
      const newRow = { ...row };
      newRow['Pool ID'] = poolAdiraValue;
      newRow['ID Lelang'] = newId;
      delete newRow['Pool Adira ID'];

      return newRow;
    });

    // Tentukan header baru (ganti Pool Adira ID → Pool ID)
    let finalHeaders = [];

    if (poolAdiraIndex !== -1) {
      finalHeaders = [...originalHeaderRow];
      finalHeaders[poolAdiraIndex] = 'Pool ID';
    } else if (newData.length > 0) {
      // fallback jika header tidak ditemukan
      finalHeaders = Object.keys(newData[0]);
    }

    finalHeaders = finalHeaders.map((h) => (h ? String(h) : ''));

    return { data: newData, headers: finalHeaders };
  } catch (err) {
    console.error('Error parsing Excel:', err);
    throw new Error('Gagal membaca dan memproses file Excel');
  }
};

/* ============================================================
   2. EXPORT ARRAY OBJECT MENJADI FILE EXCEL
   ============================================================ */
export const exportToExcel = (
  data,
  headers,
  fileName,
  bookType = 'xlsx',
  type = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
) => {
  try {
    const worksheet = XLSX.utils.json_to_sheet(data, { header: headers, skipHeader: false });

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

    const excelBuffer = XLSX.write(workbook, { bookType, type: 'array' });

    const exportBlob = new Blob([excelBuffer], { type });

    saveAs(exportBlob, `${fileName}.${bookType}`);
    toast.success('File berhasil di-download');
  } catch (err) {
    console.error('Error exporting Excel:', err);
    toast.error('Gagal membuat file Excel');
  }
};

export const exportToExcelLockColumn = (
  data,
  headers,
  fileName,
  bookType = 'xlsx',
  type = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
) => {
  try {
    const worksheet = XLSX.utils.json_to_sheet(data, { header: headers, skipHeader: false });

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

    // Lock kolom Id, Lot No, Nama Unit, Nomor Polisi, Seller agar tidak bisa diedit
    if (worksheet['!ref']) {
      const range = XLSX.utils.decode_range(worksheet['!ref']);

      // Kolom A-E (0-4): Id, Lot No, Nama Unit, Nomor Polisi, Seller
      for (let row = range.s.r + 1; row <= range.e.r; row++) {
        for (let col = 0; col <= 4; col++) {
          const cellAddress = XLSX.utils.encode_cell({ r: row, c: col });
          if (worksheet[cellAddress]) {
            worksheet[cellAddress].s = {
              ...worksheet[cellAddress].s,
              protection: { locked: true },
            };
          }
        }
      }

      worksheet['!protect'] = {
        // Proteksi worksheet
        sheet: true,
        formatCells: false,
        formatColumns: false,
        formatRows: false,
        insertColumns: false,
        insertRows: false,
        insertHyperlinks: false,
        deleteColumns: false,
        deleteRows: false,
        selectLockedCells: true,
        selectUnlockedCells: true,
        sort: false,
        autoFilter: false,
        pivotTables: false,
      };
    }

    const excelBuffer = XLSX.write(workbook, { bookType, type: 'array' });

    const exportBlob = new Blob([excelBuffer], { type });

    saveAs(exportBlob, `${fileName}.${bookType}`);
    toast.success('File berhasil di-download');
  } catch (err) {
    console.error('Error exporting Excel:', err);
    toast.error('Gagal membuat file Excel');
  }
};

export const parseCSVToPrice = (file, existingProducts) => {
  return new Promise((resolve, reject) => {
    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: function (result) {
        try {
          const data = result.data;
          const pricingUpdates = {};
          const errors = [];

          data.forEach((item, index) => {
            try {
              const id = item['Id']?.trim();
              const basePrice = item['Harga Dasar']?.trim();
              const buyItNowPrice = item['Harga Buy It Now']?.trim();

              // Lewati jika ID kosong
              if (!id) {
                toast.error(`Baris ${index + 2}: ID kosong, baris dilewati`);
                return;
              }

              // Cari apakah produk ada di data existing
              const existingProduct = existingProducts.find((p) => p.id == id);

              // Lewati jika produk tidak ditemukan
              if (!existingProduct) {
                toast.error(
                  `Baris ${index + 2}: Produk dengan ID ${id} tidak ditemukan, baris dilewati`,
                );
                return;
              }

              // Validasi dan konversi harga dasar
              let parsedBasePrice = existingProduct.product.base_price;
              if (basePrice !== undefined && basePrice !== '') {
                const basePriceNum = parsePriceToNumber(basePrice);
                if (isNaN(basePriceNum) || basePriceNum < 0) {
                  throw new Error(`Harga Dasar tidak valid: ${basePrice}`);
                }
                parsedBasePrice = basePriceNum;
              }

              // Validasi dan konversi harga buy it now
              let parsedBuyItNowPrice = existingProduct.product.direct_sales_price;
              if (buyItNowPrice !== undefined && buyItNowPrice !== '') {
                const buyItNowPriceNum = parsePriceToNumber(buyItNowPrice);
                if (isNaN(buyItNowPriceNum) || buyItNowPriceNum < 0) {
                  throw new Error(`Harga Beli Sekarang tidak valid: ${buyItNowPrice}`);
                }
                parsedBuyItNowPrice = buyItNowPriceNum;
              }

              // Tambahkan ke pricingUpdates
              pricingUpdates[id] = {
                id: parseInt(id),
                base_price: parsedBasePrice,
                direct_sales_price: parsedBuyItNowPrice,
              };
            } catch (err) {
              errors.push(`Baris ${index + 2}: ${err.message}`);
            }
          });

          // Jika ada error, tolak promise
          if (errors.length > 0) {
            reject(new Error(errors.join('\n')));
            return;
          }

          // Jika tidak ada data yang berhasil diproses
          if (Object.keys(pricingUpdates).length === 0) {
            reject(
              new Error(
                'Tidak ada data yang valid untuk diproses. Pastikan ID produk sesuai dengan data yang ada.',
              ),
            );
            return;
          }

          resolve(pricingUpdates);
        } catch (err) {
          reject(err);
        }
      },
      error: function (err) {
        reject(err);
      },
    });
  });
};

export const parsePriceToNumber = (priceString) => {
  if (!priceString) return null;

  // Hapus "Rp", spasi, dan titik (pemisah ribuan)
  const cleaned = priceString
    .toString()
    .replace(/Rp\s*/gi, '')
    .replace(/\./g, '') // hapus titik ribuan
    .replace(/,/g, '.') // ubah koma desimal ke titik
    .trim();

  return parseFloat(cleaned);
};

export const formatCurrency = (amount) => {
  if (amount === 0 || amount === null || amount === undefined) {
    return 'Rp 0';
  }

  return `Rp ${amount.toLocaleString('id-ID')}`;
};

export function formatData(data) {
  let arr = [];
  for (let i = 0; i < data.length; i++) {
    arr.push({
      id: data[i].id,
      label: data[i].name ? data[i].name : data[i].city_name,
      value: data[i].name ? data[i].name : data[i].city_name,
    });
  }
  return arr;
}

export const getPathSlug = (slug) => {
  let path = '';
  switch (slug) {
    case 'penerimaan-unit':
      path = 'acceptance';
      break;
    case 'pengiriman-unit':
      path = 'mobilization';
      break;
    case 'review-dokumen':
      path = 'review-document';
      break;
    case 'lelang':
      path = 'auction';
      break;
    case 'rilis-kendaraan':
      path = 'vehicle-release';
      break;
    case 'pelanggan':
      path = 'customer';
      break;
    case 'manajemen-konten':
      path = 'content';
      break;
    case 'pengaturan':
      path = 'settings';
      break;
    case 'laporan':
      path = 'statement';
      break;
    case 'master-data':
      path = 'master';
      break;
    default:
      path = slug;
      break;
  }
  return path;
};

export const resolveFirstAccessiblePath = (menu, productTypes = []) => {
  // Case 1 — menu normal tanpa submenu
  if (!menu.subMenu && menu.link !== '/inventory') {
    return menu.link;
  }

  // Case 2 — inventory (submenu dinamis)
  if (menu.link === '/inventory') {
    if (!productTypes.length) return '/inventory';

    return `/inventory?type=${encodeURIComponent(productTypes[0].name)}`;
  }

  // Case 3 — menu punya submenu statis
  const firstSub = menu.subMenu[0];

  if (firstSub.childs && firstSub.childs.length) {
    return menu.link + firstSub.link + firstSub.childs[0].link;
  }

  return menu.link + firstSub.link;
};

export const hasAccess = (slug, scopes) => {
  if (!slug || !scopes?.length) return false;

  return scopes.some((s) => s.slug === slug && s.permission === true);
};

export const handleCopyToClipboard = (value) => {
  navigator.clipboard.writeText(value);
  toast.success('Berhasil disalin');
};

export const isSunday = (dateString) => {
  if (!dateString) return false;
  const [year, month, day] = dateString.split('-');
  const date = new Date(year, month - 1, day);
  return date.getDay() === 0;
};

export function formatAuctionClass(value) {
  if (!value) return '-';
  return value
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}
